import {
  getBackendDomainCookie,
  parseBackendDomain,
} from 'lib-shared-backend-config';

export function resolveElevioUrlByEnvironment(
  urls: Record<'staging' | 'production', string>,
  domain: string | null,
): string {
  switch (domain) {
    case 'euw1.stag.dixa.io':
    case 'euw1.stag2.dixa.io':
    case 'euw1.stag3.dixa.io':
    case 'euw1.dev1.dixa.io':
      return urls.staging;
    case null:
    default:
      return urls.production;
  }
}

export function getBackendDomain(): string | null {
  return parseBackendDomain() ?? getBackendDomainCookie();
}

export const elevioUrls = {
  staging: {
    snowcat: 'snowcat.elevio-staging.com', // no url protocol required for snowcat
    grappa: 'https://ipa.elevio-staging.com/grappa/graphql',
    datahub: 'https://ipa.elevio-staging.com/data/graphql',
    sso: 'https://ipa.elevio-staging.com/data/dixa/sso',
  },
  production: {
    snowcat: 'snowcat.elev.io', // no url protocol required for snowcat
    grappa: 'https://ipa.elev.io/grappa/graphql',
    datahub: 'https://ipa.elev.io/data/graphql',
    sso: 'https://ipa.elev.io/data/dixa/sso',
  },
};
